/* -------------------------------------------------------------------------- */
/*                                Option group styles                */
/* -------------------------------------------------------------------------- */

@import './bq-option-group.variables';

:host {
  @apply block;
}

.bq-option-group {
  @apply flex overflow-hidden overflow-ellipsis;
  @apply bg-[--bq-option-group--background] text-[length:--bq-option-group--font-size] leading-[--bq-option-group--line-height];
  @apply pe-[--bq-option-group--label-padding-end] ps-[--bq-option-group--label-padding-start] p-b-[--bq-option-group--label-paddingY] p-i-[--bq-option-group--label-paddingY];

  &__child {
    @apply flex items-center;
  }
}

.bq-option-group__label {
  @apply pe-[--bq-option-group--label-text-padding-end] ps-[--bq-option-group--label-text-padding-start];
}

.bq-option-group__container ::slotted(bq-option) {
  @apply ps-[--bq-option-group--container-padding-start];
}
